var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { WmButton } from "@watermarkinsights/ripple-react";
import { InstitutionIcon } from "src/features/common/Icons";
import { useContext, useReducer } from "react";
import { useIntl } from "react-intl";
import translate from "src/i18n/translate";
import { AppContext } from "src/contexts/AppContext";
import { useNavigate } from "react-router-dom";
import { scrollToTop } from "src/features/common/helper";
var defaultAction = {
    type: "",
    showOrganizations: false
};
var stateReducer = function (state, action) {
    switch (action.type) {
        case "toggleOrganizations":
            return __assign(__assign({}, state), { showOrganizations: !state.showOrganizations });
        default:
            return state;
    }
};
var initialState = {
    showOrganizations: true
};
export function ContributorOrganizationInsights(_a) {
    var organizations = _a.organizations;
    var _b = useReducer(stateReducer, initialState), state = _b[0], dispatch = _b[1];
    var toggleOrganizations = function () {
        dispatch(__assign(__assign({}, defaultAction), { type: "toggleOrganizations" }));
    };
    var toggleOrganizationsLabel = useIntl().formatMessage({
        id: "app.home.toggleOrganizations"
    });
    return (_jsxs("div", { className: "my-institution-container", children: [_jsxs("div", { className: "flex-row -verticallycentered", children: [_jsx("button", { className: state.showOrganizations
                            ? "expand-button mdi  mdi-menu-down"
                            : "expand-button mdi  mdi-menu-right", onClick: toggleOrganizations, "aria-label": toggleOrganizationsLabel }), _jsx("span", { className: "my-institution", children: translate("app.home.myOrganizations") })] }), _jsx("div", { id: "organization-list-container", children: state.showOrganizations &&
                    organizations.map(function (organization) {
                        return (_jsx(OrganizationCard, { organization: organization }, "".concat(organization.uuid, " ").concat(organization.code)));
                    }) })] }));
}
var OrganizationCard = function (_a) {
    var organization = _a.organization;
    var institution = useContext(AppContext).institution;
    var navigate = useNavigate();
    var queryString = window.location.search;
    var organizationInsightsUrl = queryString.includes("locale")
        ? "/insights/institution/".concat(institution === null || institution === void 0 ? void 0 : institution.platformUuid, "/organization/").concat(organization.uuid, "/").concat(queryString)
        : "/insights/institution/".concat(institution === null || institution === void 0 ? void 0 : institution.platformUuid, "/organization/").concat(organization.uuid);
    function navigateToUrl(url) {
        scrollToTop(".home-page-header");
        navigate(url);
    }
    return (_jsxs("div", { className: "institution-name", children: [_jsx(InstitutionIcon, {}), _jsx("div", { className: "organization-button", children: _jsx(WmButton, { buttonType: "textonly", onClick: function () { return navigateToUrl(organizationInsightsUrl); }, children: _jsx("div", { className: "instiution-link", children: organization.name }) }) })] }));
};
